import { useMemo } from 'react';
import useSWR from 'swr';
import { FilterCriteria } from '@ampsec/platform-client';

export const useApiObjectData = <DataT, RenderT>(
    cacheKey: string,
    fetcher: any,
    transformer: (_dataItem: DataT) => RenderT = (dataItem) => (({ ...dataItem } as unknown) as RenderT),
    filter?: FilterCriteria,
    enabled = true,
) => {
    const updatedFilter: FilterCriteria = { ...filter };
    const swrKey = enabled ? ([cacheKey, updatedFilter] as const) : null;
    const { data: apiData, error, isLoading: isApiLoading, mutate } = useSWR(swrKey, () =>
        fetcher(cacheKey, updatedFilter),
    );
    const data = useMemo(() => (apiData ? transformer(apiData) : ({} as RenderT)), [apiData]);

    return {
        data,
        error,
        isLoading: !enabled || isApiLoading,
        refresh: mutate,
    };
};
